import { ClientOnly, Portal } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';
import { useLayoutRefs } from '../refs/refs';

export const HeadingPortal: FC<PropsWithChildren> = ({ children }) => {
  const portals = useLayoutRefs();
  return (
    <Portal container={portals.headingRef}>
      <ClientOnly>{children}</ClientOnly>
    </Portal>
  );
};

export const ProfileInfoPortal: FC<PropsWithChildren> = ({ children }) => {
  const portals = useLayoutRefs();
  return (
    <Portal container={portals.profileInfoRef}>
      <ClientOnly>{children}</ClientOnly>
    </Portal>
  );
};

export const OrgSwitcherPortal: FC<PropsWithChildren> = ({ children }) => {
  const portals = useLayoutRefs();
  return (
    <Portal container={portals.orgSwitcherRef}>
      <ClientOnly>{children}</ClientOnly>
    </Portal>
  );
};

export const HeaderRightPortal: FC<PropsWithChildren> = ({ children }) => {
  const portals = useLayoutRefs();
  return (
    <Portal container={portals.headerRightRef}>
      <ClientOnly>{children}</ClientOnly>
    </Portal>
  );
};
